export default {
  '订购主体：': '订购主体：',
  没有更多了: '没有更多了',
  '套餐编号：': '套餐编号：',
  '已使用：{used}份 剩余：{margin}份': '已使用：{used}份 剩余：{margin}份',
  '截止日期:': '截止日期:',
  '您还没订购过套餐~': '您还没订购过套餐~',
  订购: '订购',
  再次订购: '再次订购',
  返回: '返回',
  已购套餐: '已购套餐',
  '加载中...': '加载中...',
  已失效: '已失效',
  待生效: '待生效',
  生效中: '生效中',
  已停用: '已停用',
  已终止: '已终止',
  冻结中: '冻结中',
  交易成功: '交易成功',
  电子签名服务: '电子签名服务',
  '订购主体:': '订购主体:',
  元: '元',
  '暂不支持苹果手机支付，请用其他平台支付或联系服务商': '暂不支持苹果手机支付，请用其他平台支付或联系服务商',
  联系服务商: '联系服务商',
  立即结算: '立即结算',
  购买: '购买',
  以下合同均自购买日起一年内有效: '以下合同均自购买日起一年内有效',
  '当前企业的版本为{slot}，仅支持签署合同/文件。若要发起合同，请订阅购买会员版本。':
    '当前企业的版本为{slot}，仅支持签署合同/文件。若要发起合同，请订阅购买会员版本。',
  提交订单: '提交订单',
}
